import confetti from "canvas-confetti";

const STORAGE_KEY = "dj_my_tracks";
const CELEBRATED_KEY = "dj_celebrated_tracks";
const MAX_TRACKED = 30;

/** Remember a track the current browser guest requested, so we can celebrate later. */
export const rememberMyTrack = (track) => {
  if (!track?.id) return;
  try {
    const raw = JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
    const filtered = raw.filter((t) => t.id !== track.id);
    filtered.unshift({
      id: track.id,
      name: track.name || "",
      artist: track.artist || "",
      cover: track.cover || "",
    });
    localStorage.setItem(STORAGE_KEY, JSON.stringify(filtered.slice(0, MAX_TRACKED)));
  } catch {
    // localStorage unavailable — no-op
  }
};

export const isMyTrack = (trackId) => {
  if (!trackId) return false;
  try {
    const raw = JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
    return raw.some((t) => t.id === trackId);
  } catch {
    return false;
  }
};

export const findMyTrack = (trackId) => {
  if (!trackId) return null;
  try {
    const raw = JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
    return raw.find((t) => t.id === trackId) || null;
  } catch {
    return null;
  }
};

export const hasCelebrated = (trackId) => {
  if (!trackId) return true;
  try {
    const raw = JSON.parse(localStorage.getItem(CELEBRATED_KEY) || "[]");
    return raw.includes(trackId);
  } catch {
    return false;
  }
};

export const markCelebrated = (trackId) => {
  if (!trackId) return;
  try {
    const raw = JSON.parse(localStorage.getItem(CELEBRATED_KEY) || "[]");
    if (!raw.includes(trackId)) {
      raw.unshift(trackId);
      localStorage.setItem(CELEBRATED_KEY, JSON.stringify(raw.slice(0, 200)));
    }
  } catch {
    // ignore
  }
};

/** Celebrate — confetti bursts from left and right, gentle warm palette matching the site. */
export const celebrate = () => {
  const brand = ["#c4a882", "#a68968", "#8a6d4c", "#e8ddc4", "#ffffff"];
  const shoot = (originX) => {
    confetti({
      particleCount: 60,
      startVelocity: 55,
      spread: 65,
      angle: originX < 0.5 ? 60 : 120,
      origin: { x: originX, y: 0.75 },
      colors: brand,
      scalar: 0.9,
      ticks: 250,
      disableForReducedMotion: true,
    });
  };
  shoot(0.15);
  shoot(0.85);
  // Slight second wave after 300ms for a fuller feel.
  setTimeout(() => {
    confetti({
      particleCount: 80,
      spread: 100,
      startVelocity: 40,
      origin: { x: 0.5, y: 0.6 },
      colors: brand,
      scalar: 0.8,
      ticks: 220,
      disableForReducedMotion: true,
    });
  }, 320);
};
